<script lang="ts">
    import {pipe} from 'core/utils';
    import {FileViewForm} from 'shared/constants/portaro.constants';
    import {byteFormatter, encodeUri} from 'shared/utils/pipes';
    import type {IdentifiedFile, Rec} from 'typings/portaro.be.types';

    export let record: Rec;
    export let file: IdentifiedFile;
</script>

<a class="attachment-mini"
   href="/media-viewer?rootDirectory={record.directoryId}&origin={pipe(window.location.href, encodeUri())}#!?file={file.id}">

    {#if file.viewForms.includes(FileViewForm.THUMBNAIL)}
        <img class="attachment-thumbnail"
             alt={file.name}
             src="/files/{file.id}?height=40"
             height="40"/>
    {/if}

    <div class="details-container">
        <span>{file.name}</span>
        <span class="text-muted">{pipe(file.size, byteFormatter())}</span>
    </div>
</a>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .attachment-mini {
        display: flex;
        align-items: center;
        justify-content: start;
        gap: @spacing-ml;

        &:hover .attachment-thumbnail {
            opacity: 0.6;
        }

        .attachment-thumbnail {
            max-width: 60px;
            border: 1px solid @themed-border-default;
            border-radius: @border-radius-small;
            transition: opacity 0.2s ease-in-out;
        }

        .details-container {
            display: flex;
            flex-direction: column;
        }
    }
</style>